import '../chart-grid/ChartGrid.css';
import './SelectionArea.css';
export var brushOverlay = '_114vdwb0-2-0-1 _2c3zgm0-2-0-1';
export var knob = '_114vdwb1-2-0-1';
export var selectionArea = '_114vdwb3-2-0-1';
export var transparentDraggingArea = '_114vdwb2-2-0-1';